import React from "react";

import useTheme from "@styles/useTheme";
import useTranslation from "@languages/useTranslation";

import SidebarDrawerMenu from "@atoms/SidebarDrawerMenu";

import { useSidebarMenuItems } from "@molecules/SidebarMenus/useSidebarMenuItems";

import * as Styled from "./styles";

const SidebarDrawerMenus: React.FC = () => {

  const { theme } = useTheme();
  const { t } = useTranslation();

  const menuItems = useSidebarMenuItems();

  return (
    <Styled.Container>
      {
        menuItems.map(({ id, title, icon, link }) => (
          <SidebarDrawerMenu
            key={`${id}_${title}`}
            id={id}
            title={t(title)}
            icon={icon}
            link={link}
            secondaryColor={theme.colors.secondary}
            identifierColor={theme.colors.tertiary}
            type="primary"
          />
        ))
      }
    </Styled.Container>
  );
};

export default React.memo(SidebarDrawerMenus);
